(function () {
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function getCheckboxError(checkbox) {
    return document.getElementById(`${checkbox.id}-error`);
  }

  function setCheckboxError(checkbox, show) {
    const field = checkbox.closest(".field--checkbox");
    const error = getCheckboxError(checkbox);

    field?.classList.toggle("is-invalid", show);
    error?.classList.toggle("is-visible", show);
  }

  function getEmailClientError(form) {
    return form.querySelector("[data-contact-email-error]");
  }

  function setEmailError(form, show) {
    const emailInput = form.querySelector('[type="email"]');
    const error = getEmailClientError(form);

    emailInput?.classList.toggle("field__input--error", show);
    emailInput?.setAttribute("aria-invalid", show ? "true" : "false");
    error?.classList.toggle("is-visible", show);
  }

  function validateEmail(form) {
    const emailInput = form.querySelector('[type="email"]');

    if (!emailInput) return true;

    const isValid =
      emailInput.value.trim() !== "" &&
      EMAIL_PATTERN.test(emailInput.value.trim());

    setEmailError(form, !isValid);
    return isValid;
  }

  function validateCheckboxes(form) {
    const checkboxes = form.querySelectorAll(
      '.field--checkbox input[type="checkbox"][required]'
    );
    let isValid = true;

    checkboxes.forEach((checkbox) => {
      const checked = checkbox.checked;
      setCheckboxError(checkbox, !checked);
      if (!checked) isValid = false;
    });

    return isValid;
  }

  function initContactForm(form) {
    if (!form || form.dataset.contactFormInit === "true") return;

    form.dataset.contactFormInit = "true";

    const emailInput = form.querySelector('[type="email"]');

    emailInput?.addEventListener("input", () => {
      if (
        EMAIL_PATTERN.test(emailInput.value.trim()) ||
        emailInput.value.trim() === ""
      ) {
        setEmailError(form, false);
      }
    });

    emailInput?.addEventListener("blur", () => {
      if (emailInput.value.trim() !== "") {
        validateEmail(form);
      }
    });

    form
      .querySelectorAll('.field--checkbox input[type="checkbox"]')
      .forEach((checkbox) => {
        checkbox.addEventListener("change", () => {
          if (checkbox.checked) {
            setCheckboxError(checkbox, false);
          }
        });
      });

    form.addEventListener(
      "invalid",
      (event) => {
        const target = event.target;

        if (!(target instanceof HTMLInputElement)) return;

        if (target.type === "email") {
          event.preventDefault();
          validateEmail(form);
          target.focus();
          return;
        }

        if (target.type === "checkbox" && target.required) {
          event.preventDefault();
          setCheckboxError(target, true);
          target.focus();
        }
      },
      true
    );

    form.addEventListener("submit", (event) => {
      const emailValid = validateEmail(form);
      const checkboxesValid = validateCheckboxes(form);

      if (!emailValid || !checkboxesValid) {
        event.preventDefault();
        event.stopPropagation();

        if (!emailValid) {
          emailInput?.focus();
        } else {
          const firstInvalidCheckbox = form.querySelector(
            '.field--checkbox.is-invalid input[type="checkbox"]'
          );
          firstInvalidCheckbox?.focus();
        }
      }
    });
  }

  function initContactForms(root = document) {
    root.querySelectorAll("form[data-contact-form]").forEach(initContactForm);
  }

  initContactForms();
  document.addEventListener("shopify:section:load", (event) => {
    initContactForms(event.target);
  });
})();
